import { useDataGridFetcher } from '@/hooks/api/useDataGridFetcher';
import { queryFunction, queryKey } from './query';
import { SelectedFilters } from '@/components/FilterData/types';
import { normalizeSearchQuery } from '@/components/Search/utils';
import { UUID } from '@/api/generatedApi';

export const useFetchCrossTenantVisualSearch = ({
  assetId,
  assetTenantId,
  searchTenantId,
  searchQuery,
  selectedFilters,
  sizeThreshold,
  onError,
  enabled = true,
}: {
  assetId: UUID;
  assetTenantId: UUID;
  searchTenantId: UUID;
  searchQuery?: string;
  selectedFilters?: SelectedFilters;
  sizeThreshold?: number;
  onError?: (error: Error) => void;
  enabled?: boolean;
}) => {
  const normalizedSearchQuery = normalizeSearchQuery(searchQuery);

  return useDataGridFetcher({
    queryKey: parameters =>
      queryKey({
        assetId,
        assetTenantId,
        searchTenantId,
        searchQuery: normalizedSearchQuery,
        selectedFilters,
        sizeThreshold,
        ...parameters,
      }),
    queryFn: parameters =>
      queryFunction({
        assetId,
        assetTenantId,
        searchTenantId,
        searchQuery: normalizedSearchQuery,
        selectedFilters,
        sizeThreshold,
        ...parameters,
      }),
    onError,
    enabled,
  });
};
